// TODO add retry logic
export const request = async (url: string, options: RequestInit): Promise<Response> => {
    const response = await fetch(url, options);
    
    // If response is not ok (status 400-599), throw an error with response details
    if (!response.ok) {
        const error = new Error(`HTTP ${response.status}: ${response.statusText}`) as any;
        error.response = {
            status: response.status,
            statusText: response.statusText
        };
        
        // For 403 errors, add a flag to indicate potential LDAP group issue
        if (response.status === 403) {
            error.isLdapGroupError = true;
        }

        
        throw error;
    }
    
    return response;
};